import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl} from '@angular/forms';
import {TemplatesSearch} from '../../../models/templates-search.interface';
import {Master} from '../../../models/master.interface';

@Component({
  selector: 'app-templates-filter',
  templateUrl: './templates-filter.component.html',
  styleUrls: ['./templates-filter.component.scss']
})
export class TemplatesFilterComponent implements OnInit {

  searchForm = this.formBuilder.group({
    description: [''],
    category: [''],
    subject: [''],
    status: ['ACTIVE']
  });

  get descriptionControl(): FormControl {
    return this.searchForm.get('description') as FormControl;
  }
  get categoryControl(): FormControl {
    return this.searchForm.get('category') as FormControl;
  }
  get subjectControl(): FormControl {
    return this.searchForm.get('subject') as FormControl;
  }
  get statusControl(): FormControl {
    return this.searchForm.get('status') as FormControl;
  }

  @Input()
  templateCategories!: Master[];

  @Output()
  search: EventEmitter<TemplatesSearch> = new EventEmitter<TemplatesSearch>();

  constructor(private formBuilder: FormBuilder) { }

  ngOnInit(): void {
  }

  handleSubmit(): void {
    const dto: TemplatesSearch = {
      description: this.descriptionControl.value,
      category: this.categoryControl.value,
      subject: this.subjectControl.value,
      status: this.statusControl.value
    };
    this.search.emit(dto);
  }

  clean(): void {
    this.search.emit({});
  }

}
